<template>
  <div>
    <button
      :disabled="disabled"
      :title="!isSubscribedUser ? 'Доступно при наличии платной подписки' : ''"
      @click.prevent="handleOpenDropdown"
      v-click-outside="() => (isOpenDropdown = false)"
      :class="['tag-lots-button', { disabled: disabled || !isSubscribedUser }]"
    >
      <TagIcon color="#7D919B" />
      <span class="text">Метки</span>
      <div :class="['icon', { rotated: isOpenDropdown }]">
        <Arrow :width="24" :height="24" fill="#79919c" />
      </div>
      <div
        @click.stop
        :class="[
          'form-control',
          'form-control-light',
          'tag-lots-button-dropdown',
          { 'tag-lots-button-dropdown-open': isOpenDropdown },
          { right: dropdownRight },
        ]"
      >
        <button
          class="line"
          v-for="tag in tags"
          :key="tag.id"
          @click="toggleTag('tag', tag.id)"
        >
          <TagSvgWithColor :tag="tag" />
          <p class="label">{{ tag.name }}</p>
        </button>
        <button class="line" @click="toggleTag('untag', -1)">
          <TagSvgWithColor
            :tag="{ form: 'square', color: '#7D919B' }"
            :is-filled="false"
          />
          <p class="label">Снять метку</p>
        </button>
      </div>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TagSvgWithColor from "./TagSvgWithColor.vue";
import { showSubscriptionToast } from "@/services/subscriptionNotification";
import TagIcon from "./TagIcon.vue";
import Arrow from "@/assets/icons/arrow.svg";

export default {
  name: "TagLotsButton",
  components: { TagSvgWithColor, TagIcon, Arrow },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: true,
    },
    dropdownRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { isOpenDropdown: false };
  },
  computed: {
    ...mapGetters("tags", ["tags"]),
    ...mapGetters("auth", ["authorities"]),
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("subscriptions", ["subscriptions"]),
    isSubscribedUser() {
      return this.authorities.includes("ROLE_SUBSCRIBED_USER");
    },
  },
  methods: {
    ...mapActions("subscriptions", ["getSubscriptions"]),
    toggleTag(action, tagId) {
      this.$emit("toggle-tag", action, tagId);
      this.isOpenDropdown = false;
    },
    async handleOpenDropdown() {
      if (this.isSubscribedUser) {
        this.isOpenDropdown = !this.isOpenDropdown;
        return;
      }

      await this.getSubscriptions(this.profileId);
      showSubscriptionToast(this.subscriptions, this.$toast);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

button:disabled {
  opacity: 0.5;
}

.tag-lots-button {
  display: flex;
  align-items: center;
  position: relative;
  height: 48px;
  transition: @trans;
  padding: 10px;
  &.disabled {
    opacity: 0.5;
    cursor: auto;
  }
  &-dropdown {
    display: none;
    position: absolute;
    z-index: 999;
    left: -1px;
    top: 48px;
    width: max-content;
    height: max-content;
    background-color: #ffffff;
    padding: 0;
    box-shadow: 0px 4px 25px 0px #00000040;
    &-open {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }

    .line {
      display: flex;
      align-items: center;
      height: 34px;
      gap: 17px;
      padding: 0 15px;
      &:hover {
        background-color: #f6f7f8;
      }
      .label {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: #7d919b;
      }
    }
  }
  &-dropdown.right {
    left: auto;
    right: -1px;
  }

  &:hover:not(.disabled) {
    background-color: fade(@bg-color-light, 50%);
  }

  .text {
    margin-left: 5px;
    margin-right: 10px;
    color: #79919c;
  }

  .icon {
    margin-top: 5px;
  }

  .rotated {
    transform: rotate(180deg);
    margin-top: 0;
  }
}
</style>
